<template>
  <div class="animated fadeIn">
    <h1 class="title">{{ $t('messages.userProfile') }}</h1>
    <div class="alert alert-success" role="alert" v-if="!form.profileComplete">
      <h4 class="alert-heading">Welcome to your Bodytone profile page!</h4>
      <p>Please fill your personal information to obtain a better training experience</p>
    </div>
    <b-row>
    <b-col sm="8" md="8">
    <b-card no-body>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
        <b-row>
          <b-col lg="6">
              <b-form-group id="firstNameInputGroup1"
                    :label="$t('messages.name')"
                    label-for="name">
                <b-form-input id="name"
                    type="text"
                    v-model.lazy.trim="$v.form.name.$model"
                    :state="chkState('name')"
                    aria-describedby="input1LiveFeedback1"
                    :placeholder="$t('messages.name')"
                    autocomplete='given-name'
                    autofocus />
                    <div v-if="$v.form.$error" class="invalid-feedback">
                      <div v-if="!$v.form.name.required">{{ $t('messages.error.required') }}</div>
                      <div v-if="!$v.form.name.minLength">{{ $t('messages.error.minLength', { value: $v.form.name.$params.minLength.min }) }} </div>
                      <div v-if="!$v.form.name.maxLength">{{ $t('messages.error.maxLength', { value: $v.form.name.$params.maxLength.max }) }} </div>
                    </div>
              </b-form-group>
              <b-form-group id="lastNameInputGroup2"
                    :label="$t('messages.surname')"
                    label-for="Surname">
                <b-form-input id="surname"
                    type="text"
                    v-model.lazy.trim="$v.form.surname.$model"
                    :state="chkState('surname')"
                    aria-describedby="input1LiveFeedback2"
                    placeholder="Surname"
                    autocomplete='family-name'/>
                    <div v-if="$v.form.$error" class="invalid-feedback">
                      <div v-if="!$v.form.surname.required">{{ $t('messages.error.required') }}</div>
                      <div v-if="!$v.form.surname.minLength">{{ $t('messages.error.minLength', { value: $v.form.surname.$params.minLength.min }) }} </div>
                      <div v-if="!$v.form.surname.maxLength">{{ $t('messages.error.maxLength', { value: $v.form.surname.$params.maxLength.max }) }} </div>
                    </div>
              </b-form-group>
              <b-form-group id="userNameInputGroup3"
                    :label="$t('messages.nickname')"
                    label-for="userName">
                <b-form-input id="nickname"
                    type="text"
                    v-model.trim="$v.form.nickname.$model"
                    :state="chkState('nickname')"
                    aria-describedby="input1LiveFeedback3"
                    placeholder="Nickname"
                    autocomplete='nickname' />
                <div v-if="$v.form.$error" class="invalid-feedback">
                      <div v-if="!$v.form.nickname.required">{{ $t('messages.error.required') }}</div>
                      <div v-if="!$v.form.nickname.minLength">{{ $t('messages.error.minLength', { value: $v.form.nickname.$params.minLength.min }) }} </div>
                      <div v-if="!$v.form.nickname.maxLength">{{ $t('messages.error.maxLength', { value: $v.form.nickname.$params.maxLength.max }) }} </div>
                    </div>
              </b-form-group>
              <b-row>
                <b-col md="6">
                  <b-form-group id="passInputGroup5"
                    :label="$t('messages.tel')"
                    label-for="phone">
                    <b-form-input id="tel"
                        v-model.lazy="$v.form.tel.$model"
                        :state="chkState('tel')"
                        aria-describedby="input1LiveFeedback5"
                       :placeholder="$t('messages.tel')"
                        autocomplete='Phone number' />
                    <b-form-invalid-feedback id="input1LiveFeedback5">
                      {{ (duplicateTel) ?  'Phone number already used'   : 'Required field and must be numeric values only' }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="confPassInputGroup6"
                    :label="$t('messages.pin')"
                    label-for="pin">
                    <b-form-input id="pin"
                        v-model.trim="$v.form.pin.$model"
                        :state="chkState('pin')"
                        aria-describedby="input1LiveFeedback6"
                        placeholder="PIN"
                        autocomplete='new-password' />
                    <div v-if="$v.form.$error" class="invalid-feedback">
                      <div v-if="!$v.form.pin.required">{{ $t('messages.error.required') }}</div>
                      <div v-if="!$v.form.pin.minLength">{{ $t('messages.error.minLength', { value: $v.form.pin.$params.minLength.min }) }} </div>
                      <div v-if="!$v.form.pin.maxLength">{{ $t('messages.error.maxLength', { value: $v.form.pin.$params.maxLength.max }) }} </div>
                      <div v-if="!$v.form.pin.numeric">{{ $t('messages.error.numeric', { value: $v.form.pin.$params.numeric }) }} </div> 
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="confPassInputGroup6"
                    :label="$t('messages.dateofbirth')"
                    label-for="dateofbirth">
                    <b-form-input id="dateofbirth" type="date" 
                        v-model.trim="$v.form.dateofbirth.$model"
                        :state="chkState('dateofbirth')"
                        aria-describedby="input1LiveFeedback6"
                        placeholder="Enter dateofbirth"
                        autocomplete='dateofbirth' />
                    <div v-if="$v.form.$error" class="invalid-feedback">
                      <div v-if="!$v.form.dateofbirth.required">{{ $t('messages.error.required') }}</div>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group id="confPassInputGroup6"
                    :label="$t('messages.gender')"
                    label-for="gender">
                    <b-form-select id="gender"
                      size="lg"
                      aria-describedby="input1LiveFeedback6"
                      :plain="true"
                      v-model.trim="$v.form.gender.$model"
                      :value="userData.gender">
                        
                        <option value="male">{{ $t('messages.male') }} </option>
                        <option value="female">{{ $t('messages.female') }}</option>
                     </b-form-select>
                   <div v-if="$v.form.$error" class="invalid-feedback">
                      <div v-if="!$v.form.gender.required">{{ $t('messages.error.required') }}</div>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

            <br/>
        </b-col>
        <b-col lg="6"> 
            <b-form-group id="firstNameInputGroup11w"
                :label="$t('messages.weight')"
                label-for="weight">
                <b-input-group>
                    <b-form-input id="weight"
                      type="text"
                      v-model.trim="$v.form.weight.$model"
                      :state="chkState('weight')"
                      aria-describedby="input1LiveFeedback1"
                      placeholder="weight"
                      autocomplete='weight'
                      autofocus />
                    <div v-if="$v.form.$error" class="invalid-feedback">
                      <div v-if="!$v.form.weight.required">{{ $t('messages.error.required') }}</div>
                      <div v-if="!$v.form.weight.minValue">{{ $t('messages.error.minValue', { value: $v.form.weight.$params.minValue.min }) }} </div>
                      <div v-if="!$v.form.weight.maxValue">{{ $t('messages.error.maxValue', { value: $v.form.weight.$params.maxValue.max }) }} </div>
                      <div v-if="!$v.form.weight.numeric">{{ $t('messages.error.numeric', { value: $v.form.weight.$params.numeric }) }} </div> 
                    </div>
                  <b-input-group-append v-if="!$v.form.$error"><b-input-group-text>kg</b-input-group-text></b-input-group-append>
                </b-input-group>
 
            </b-form-group>
            <b-form-group id="firstNameInputGroup1"
                :label="$t('messages.height')"
                label-for="height">
                <b-input-group>
                    <b-form-input id="height"
                      type="text"
                      v-model.lazy.trim="$v.form.height.$model"
                      :state="chkState('height')"
                      aria-describedby="input1LiveFeedback1"
                      placeholder="height"
                      autocomplete='height'
                      autofocus />
                    <div v-if="$v.form.$error" class="invalid-feedback">
                      <div v-if="!$v.form.height.required">{{ $t('messages.error.required') }}</div>
                      <div v-if="!$v.form.height.minValue">{{ $t('messages.error.minValue', { value: $v.form.height.$params.minValue.min }) }} </div>
                      <div v-if="!$v.form.height.maxValue">{{ $t('messages.error.maxValue', { value: $v.form.height.$params.maxValue.max }) }} </div>
                      <div v-if="!$v.form.height.numeric">{{ $t('messages.error.numeric', { value: $v.form.height.$params.numeric }) }} </div> 
                    </div>
                 <b-input-group-append v-if="!$v.form.$error"><b-input-group-text>cm</b-input-group-text></b-input-group-append>
                </b-input-group>
            </b-form-group>
            <b-form-group id="firstNameInputGroup1"
                label="FTP"
                label-for="ftp">
                <b-form-input id="ftp"
                    type="text"
                    v-model.lazy.trim="$v.form.ftp.$model"
                    :state="chkState('ftp')"
                    aria-describedby="input1LiveFeedback1"
                    placeholder="ftp"
                    autocomplete='ftp'
                    autofocus />
                    <div v-if="$v.form.$error" class="invalid-feedback">
                      <div v-if="!$v.form.ftp.required">{{ $t('messages.error.required') }}</div>
                      <div v-if="!$v.form.ftp.minValue">{{ $t('messages.error.minValue', { value: $v.form.ftp.$params.minValue.min }) }} </div>
                      <div v-if="!$v.form.ftp.maxValue">{{ $t('messages.error.maxValue', { value: $v.form.ftp.$params.maxValue.max }) }} </div>
                      <div v-if="!$v.form.ftp.numeric">{{ $t('messages.error.numeric', { value: $v.form.ftp.$params.numeric }) }} </div> 
                    </div>
            </b-form-group>
            <b-form-group id="firstNameInputGroup1"
                label="FTHR"
                label-for="hrmax">
                <b-form-input id="hrMax"
                    type="text"
                    v-model.lazy.trim="$v.form.hrMax.$model"
                    :state="chkState('hrMax')"
                    aria-describedby="input1LiveFeedback1"
                    placeholder="Enter FTHR"
                    autocomplete='hrmax'
                    autofocus />
                    <div v-if="$v.form.$error" class="invalid-feedback">
                      <div v-if="!$v.form.hrMax.required">{{ $t('messages.error.required') }}</div>
                      <div v-if="!$v.form.hrMax.numeric">{{ $t('messages.error.numeric', { value: $v.form.hrMax.$params.numeric }) }} </div> 
                    </div>
            </b-form-group>
        </b-col>
    </b-row>
    <b-col>
      <b-row>
        <b-button type="submit" variant="primary" :disabled="$v.form.$invalid || submitted || loading">
          {{ $t('messages.update') }}
        </b-button>
        <pulse-loader :loading="loading" color="white" size="10px"></pulse-loader>
      </b-row>
    </b-col>
   
    <!-- <b-button class="ml-1" type="reset" variant="danger" :disabled="!isDirty">Reset</b-button> -->
     </b-form>
    </b-card-body>
    </b-card>
    </b-col>
     <b-col sm="4" md="4">
        <b-card no-body>
            <b-card-header>
                <i class="icon-user"></i>   {{ $t('messages.userImage') }}
            </b-card-header>
        <b-card-body>
            <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
                <b-row align-h="center">
                    <b-col lg="12">
                        <b-row align-h="center">
                            <b-col lg="3">
                                <img v-if="!selectedFile" :src="defaultImage" class="fotoCard" alt="profile photo" />
                                <img v-else :src="selectedFile" class="fotoCard" alt="profile photo" />
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="12">
                        <b-row align-h="center">
                            <b-form-group style="margin-top:20px">
                                <b-form-file accept=".jpg, .png, .gif" v-model="photo" @change="onSelectedFile" ref="fileInput" id="fileInput" :plain="true"></b-form-file>
                            </b-form-group>
                        </b-row>
                    </b-col>
                    <b-col lg="12">
                        <b-row align-h="center">
                            <b-button @click="onResetImage">Cancelar</b-button>
                            <b-button style="margin-left:8px" @click="photoUpload" variant="primary" :disabled="!photo">Guardar</b-button>
                        </b-row>
                    </b-col>
                </b-row>
            </b-form>
        </b-card-body>
        </b-card>
       
     </b-col>
    </b-row>

 <b-row>
    <b-col sm="8" md="8">
    <b-card no-body>
        <b-card-header>
          <i class="fa fa-lock"></i>   {{ $t('messages.forgetPassword') }}
        </b-card-header>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmitPass" v-on:reset.prevent="onReset" novalidate>
        <b-row>
          <b-col lg="6">

        <div class="form-group" :class="{ 'form-group--error': $v.form2.password.$error }">
          <label class="form__label">{{ $t("messages.password") }}</label>
          <input class="form-control" type="password" v-model.trim="$v.form2.password.$model"/>
        </div>
        <div v-if="$v.form2.$error">
          <div class="error" v-if="!$v.form2.password.required">{{ $t('messages.error.required') }}</div>
          <div class="error" v-if="!$v.form2.password.minLength">{{ $t('messages.error.minLength', { field: $t("messages.password"), value: $v.form2.password.$params.minLength.min }) }} </div>
          <div class="error" v-if="!$v.form2.password.maxLength">{{ $t('messages.error.maxLength', { field: $t("messages.password"), value: $v.form2.password.$params.maxLength.max }) }} </div>
        </div>

        <div class="form-group" :class="{ 'form-group--error': $v.form2.repeatPassword.$error }">
          <label class="form__label">{{ $t("messages.repeatPassword") }}</label>
          <input class="form-control" type="password" v-model.lazy="$v.form2.repeatPassword.$model" data-vv-validate-on="blur" />
        </div>
        <div v-if="$v.form2.$error">
          <div class="error" v-if="!$v.form2.repeatPassword.sameAsPassword"> {{ $t('messages.error.passwordIdentical') }}</div>
        </div>

          
        <b-button type="submit" variant="primary" :disabled="$v.form2.$invalid || submitted || loading">
          {{ $t('messages.update') }}
        </b-button>
        <pulse-loader :loading="loading" color="white" size="10px"></pulse-loader>

      </b-col>
    </b-row>
        </b-form>
      </b-card-body>
    </b-card>
    </b-col>
  
 </b-row>
     <b-modal title="Contraseña actual"  v-model="passModal" @ok="reconnect">
       {{ $t('messages.passwordExpired') }}
      <input class="form-control" type="password" v-model="currentPassword" />
    </b-modal>
  </div>
  
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, numeric, minLength, maxLength, helpers, minValue, maxValue, sameAs } from "vuelidate/lib/validators"
import { mapState } from 'vuex'
import image from '../assets/user_profile.png'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
const fb = require('../firebaseConfig.js')

const mustAccept = value => {
  return Boolean(value)
}
const strongPass = helpers.regex('strongPass', /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/)

export default {
  name: "ValidationForms",
 components: {
    PulseLoader
  },
  data() {
    return {
       passModal: false,
       currentPassword: null,
        file: null,
        loading: false,
        //form: null,
        feedBack: 'secondary',
        submitted: false,
        photo: null,
        selectedFile: null,
        defaultImage: image,
        duplicateTel: false,
        userData: {},
        form2: {
          password: "",
          repeatPassword:""
        },
        form: {
          name: '',
          surname: '',
          nickname: '',
          pin: '',
          tel: '',
          gender: '',
          dateofbirth: '',
          weight: 0,
          height: '', 
          ftp: '', 
          hrMax: '',
          profileComplete: true

        }
    }
  },

  mounted(){
      this.$nextTick( () =>{
          this.$store.dispatch("fetchUserImage").then(image => {
              this.defaultImage = image
            }, error=>{
                this.defaultImage = this.currentUser.photoURL 
            })
            // if(this.currentUser.photoURL && this.currentUser.photoURL != ''){
            //   this.defaultImage = this.currentUser.photoURL 
            // } 
            this.$store.dispatch("fetchUserData").then(user => {
              if(user.gender != undefined){
              user.gender = user.gender.toLowerCase() }
             this.userData = user;
            //this.form = user
              Object.assign(this.form, user);

             }, error => {
             console.error('No user data')
          })
      })
    
  },
  computed: {
    //formStr() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$anyError },
    isDirty() { return this.$v.form.$anyDirty },
    invCheck() { return 'You must accept before submitting' },
    ...mapState(['currentUser']),

    genderLowerCase() {
      return this.userData.gender.toLowerCase().trim();
    }
  },
  mixins: [validationMixin],
  validations: {
    form2: {
        password: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(10)
        },
        repeatPassword: {
            sameAsPassword: sameAs('password')
        }
    },
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(64)
      },
      surname: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(64)
      },
      nickname: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(12)
      },
      pin: {
        required,
        numeric,
        minLength: minLength(4),
        maxLength: maxLength(4)
      },
      tel: {
        required,
        numeric
      },
      gender: {
        required
      },
      dateofbirth: {
        required
      },
      weight: {
        required,
        numeric,
        minValue: minValue(1),
        maxValue: maxValue(300)

      },
      height: {
        required,
        numeric,
        minValue: minValue(0),
        maxValue: maxValue(300)
      },
      ftp: {
        required,
        numeric,
        minValue: minValue(0),
        maxValue: maxValue(500)
      },
      hrMax: {
        required,
        numeric
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          this.submitted = true
          this.feedBack = 'info'
        })
      }
    },

    onSubmitPass(){
       this.currentUser.updatePassword(this.form2.password).then(()=> {
          this.showSuccessMsg({message: this.$t('messages.passwordUpdated')})
      }).catch((error)=> {
        this.passModal = true
        this.currentPassword = null
      });
    },
    reconnect(){
      this.passModal = false
       this.$store.dispatch('reauthenticate', { pass: this.currentPassword}).then((res) => {
        this.onSubmitPass()
      }, error => {
        this.showErrorMsg({message: this.$t('messages.passwordNotValid')});
      }
    )

    },
    onReset() {
      // Reset validation
      this.form = Object.assign({}, formShape)
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
        this.feedBack = 'secondary'
      })
    },
    chkState(val) {
      const field = this.$v.form[val]
      if(val==='tel' && this.duplicateTel === true){
        this.duplicateTel == false
        return !field.$dirty
      }
      return !field.$dirty || !field.$invalid
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      if(this.isValid){
        this.form.profileComplete = true
        this.loading = true
        this.$store.dispatch('saveProfile', { form: this.form}).then(response => {
          if(response.status && response.status === 200){
            this.duplicateTel = false
            this.showSuccessMsg({message: this.$t('messages.profileUpdated') })
          }else if(response.status && response.status === 201){
            this.duplicateTel = true
            this.chkState('tel')
            this.showErrorMsg({message: 'Phone number already exists'});
          }else{
            this.showErrorMsg({message: 'Profile update error'});
          }
          this.loading = false
        }, error => {
          console.log(error);
          this.showErrorMsg({message: error});
          this.loading = false
        })
      }

    },
    onResetImage(e) {
        this.selectedFile = null
        this.file = null
        this.$refs['fileInput'].reset()
    },
    onSelectedFile(e) {
        if(e.target.files){
            let size = e.target.files[0].size;
            if(size > 1000000) { // 1Mb
                this.onResetImage()
                this.showErrorMsg({message: 'The file exceeds the limit allowed (1Mb)'});
                return;
            }
            const file = e.target.files[0];
            this.selectedFile = URL.createObjectURL(file);
        }
    },
     
    photoUpload() {
        if (this.photo) {
            fb.storage.child(this.currentUser.uid).put(this.photo).then( (snapshot)=> {
                snapshot.ref.getDownloadURL().then ( (url) => {
                  this.currentUser.updateProfile({photoURL: url}).then(res => {
                    this.showSuccessMsg({message: 'Profile photo saved'})
                    }).catch( (err) => {
                         this.showErrorMsg({message: err});
                    });
                })
            }).catch( (err) => {
                this.showErrorMsg({message: err});
            });
        }
    }
  },
  notifications: {
      showSuccessMsg: { 
          title: 'Done!',
          message: 'Profile correctly updated ',
          type: 'success'
      },
      showErrorMsg: { 
          title: 'Error',
          message: 'Something went wrong',
          type: 'error'
      }
  }
}
</script>

<style scoped>
  .btn.disabled {
    cursor: auto;
  }
  .jumbo {
    height: 50px
  }

  .fotoCard{border-radius:45px;border:1px solid #13b405;width:100px;height:100px;text-align:center;overflow:hidden;position: relative;object-fit:cover;
  }

</style>



// WEBPACK FOOTER //
// src/components/Profile.vue